import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconPowerTimelessRain({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.84842 22.5665C6.62649 23.178 6.93075 23.5759 7.42175 23.7549C7.91275 23.9339 8.40255 23.8247 8.62627 23.2132C8.84821 22.6017 8.51293 20.76 8.51293 20.76C8.51293 20.76 7.07095 21.955 6.84902 22.5665H6.84842Z"
        fill="white"
      />
      <path
        d="M11.7762 22.5665C11.5537 23.178 11.8585 23.5759 12.3495 23.7549C12.8405 23.9339 13.3303 23.8247 13.5541 23.2132C13.776 22.6017 13.4407 20.76 13.4407 20.76C13.4407 20.76 11.9987 21.955 11.7768 22.5665H11.7762Z"
        fill="white"
      />
      <path
        d="M16.704 22.5665C16.4814 23.178 16.7863 23.5759 17.2773 23.7549C17.7683 23.9339 18.2581 23.8247 18.4818 23.2132C18.7037 22.6017 18.3684 20.76 18.3684 20.76C18.3684 20.76 16.9265 21.955 16.7045 22.5665H16.704Z"
        fill="white"
      />
      <path
        d="M21.6317 22.5665C21.4092 23.178 21.7141 23.5759 22.2051 23.7549C22.6961 23.9339 23.1859 23.8247 23.4096 23.2132C23.6315 22.6017 23.2962 20.76 23.2962 20.76C23.2962 20.76 21.8543 21.955 21.6323 22.5665H21.6317Z"
        fill="white"
      />
      <path
        d="M9.31229 26.6393C9.09036 27.2508 9.39462 27.6487 9.88562 27.8277C10.3766 28.0066 10.8664 27.8975 11.0901 27.286C11.3121 26.6745 10.9768 24.8328 10.9768 24.8328C10.9768 24.8328 9.53482 26.0277 9.31289 26.6393H9.31229Z"
        fill="white"
      />
      <path
        d="M14.2401 26.6393C14.0176 27.2508 14.3224 27.6487 14.8134 27.8277C15.3044 28.0066 15.7942 27.8975 16.0179 27.286C16.2399 26.6745 15.9046 24.8328 15.9046 24.8328C15.9046 24.8328 14.4626 26.0277 14.2407 26.6393H14.2401Z"
        fill="white"
      />
      <path
        d="M19.1678 26.6393C18.9453 27.2508 19.2502 27.6487 19.7412 27.8277C20.2322 28.0066 20.722 27.8975 20.9457 27.286C21.1676 26.6745 20.8323 24.8328 20.8323 24.8328C20.8323 24.8328 19.3903 26.0277 19.1684 26.6393H19.1678Z"
        fill="white"
      />
      <path
        d="M21.7595 9.51413C21.7124 9.51413 21.6671 9.5195 21.6205 9.52129C21.0973 7.3121 19.1178 5.66669 16.7487 5.66669C14.2597 5.66669 12.1997 7.48272 11.8095 9.86135C11.4987 9.77484 11.1736 9.72532 10.8341 9.72532C9.11054 9.72532 7.67155 10.9287 7.30345 12.5395C5.95574 13.0692 5 14.3776 5 15.9132C5 17.9148 6.62214 19.5375 8.62432 19.5375H21.7601C24.5289 19.5375 26.7727 17.2937 26.7727 14.5261C26.7727 11.7585 24.5283 9.51353 21.7601 9.51353L21.7595 9.51413Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.963 4.61794C22.5659 4.21505 23.2748 4 24 4C24.9725 4 25.9051 4.38631 26.5928 5.07394C27.2804 5.76158 27.6667 6.69421 27.6667 7.66667C27.6667 8.39186 27.4517 9.10078 27.0488 9.70376C26.8334 10.0261 26.5694 10.3105 26.2681 10.5477C25.2915 9.44204 23.9145 8.69822 22.3642 8.54351C22.0065 7.60248 21.4201 6.77396 20.6723 6.12699C20.9551 5.51572 21.4013 4.9932 21.963 4.61794ZM25.3832 11.0624C24.7186 11.3332 23.9889 11.403 23.2847 11.2629C22.5734 11.1214 21.9201 10.7722 21.4073 10.2594C20.8945 9.7466 20.5453 9.09326 20.4038 8.382C20.3267 7.99404 20.3132 7.59836 20.3619 7.21007C20.7414 7.60639 21.0564 8.065 21.2905 8.569C21.4026 8.81038 21.4961 9.06217 21.5691 9.32252L21.5696 9.32418C21.5879 9.38936 21.6049 9.45507 21.6205 9.52129C21.6392 9.52057 21.6576 9.51928 21.676 9.51799L21.676 9.51799C21.7036 9.51606 21.7313 9.51413 21.7595 9.51413L21.7601 9.51353C23.1847 9.51353 24.4706 10.1081 25.3832 11.0624ZM24 8H25.3334C25.4218 8 25.5066 7.96488 25.5691 7.90237C25.6316 7.83986 25.6667 7.75507 25.6667 7.66667C25.6667 7.57826 25.6316 7.49348 25.5691 7.43096C25.5066 7.36845 25.4218 7.33333 25.3334 7.33333H24.3334V5.66667C24.3334 5.57826 24.2983 5.49348 24.2357 5.43096C24.1732 5.36845 24.0884 5.33333 24 5.33333C23.9116 5.33333 23.8269 5.36845 23.7643 5.43096C23.7018 5.49348 23.6667 5.57826 23.6667 5.66667V7.66667C23.6667 7.75507 23.7018 7.83986 23.7643 7.90237C23.8269 7.96488 23.9116 8 24 8Z"
        fill="white"
      />
    </svg>
  );
}
